import { EpiLink, MaterialIcon } from '@api/types';
import { MdIcon, SmartLink } from '@components';
import { styled } from '@mui/material';
import React from 'react';

export type LinkBlockProps = {
  children?: React.ReactNode;
  link?: EpiLink;
  icon?: MaterialIcon;
};

const Wrapper = styled('div')<LinkBlockProps>``;

export const LinkBlock = ({ link, icon }: LinkBlockProps) => {
  const iconComponent = <MdIcon iconName={icon} />;
  return (
    <Wrapper className='link-block'>
      <SmartLink {...link} icon={iconComponent} />
    </Wrapper>
  );
};
